






















import { Vue, cookies, servicesURL, webClientID, requestHeaders, getCookie, headers } from '../../constants/constants'
import ReviewCard from '../review-card/ReviewCard.vue'
import axios from 'axios';

export default Vue.component('profile-reviews', {
  props: {
    reviewsData: {
      required: true,
      type: Object
    },
    userUuid: {
      required: true,
      type: String
    }
  },
  components: {
    'review-card': ReviewCard
  },
  data () {
    return {
      reviews: [],
      count: null,
      page: 1,
      pageSize: 20,
      loadingReviews: false
    }
  },
  computed: {
    nextPage () {
      return this.reviews.length < this.count
      ? this.page + 1
      : null
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      this.reviews = this.reviewsData.data
      this.page = this.reviewsData.page,
      this.count = this.reviewsData.count
    },
    loadMoreReviews () {
      const params = `page=${this.nextPage}&pageSize=${this.pageSize}`;
      this.loadingReviews = true
      axios({
        method: "GET",
        url: servicesURL.timeline.reviews(this.userUuid, params),
        headers
      })
      .then(res => {
        this.page = res.data.page
        this.count = res.data.count
        this.reviews = this.reviews.concat(res.data.data);
        this.loadingReviews = false;
      })
      .catch(error => {
          console.log("error", error)
      });
    }
  }
})
